import { get, post, patch, del } from './client.js';

const base        = (wsId)          => `/workspaces/${wsId}/custom-objects`;
const fieldBase   = (wsId, objId)   => `${base(wsId)}/${objId}/fields`;
const recordBase  = (wsId, objId)   => `${base(wsId)}/${objId}/records`;
const relBase     = (wsId, objId)   => `${base(wsId)}/${objId}/relationships`;
// CO-011d: bracket-notation serializer so filters[fieldId][op]=... reaches the backend
// unchanged for flat params; nested objects use bracket notation without percent-encoding brackets
const qs = (p = {}) => {
  if (!p || !Object.keys(p).length) return '';
  const parts = [];
  for (const [k, v] of Object.entries(p)) {
    if (v === null || v === undefined) continue;
    if (typeof v === 'object' && !Array.isArray(v)) {
      for (const [k2, v2] of Object.entries(v)) {
        if (v2 === null || v2 === undefined) continue;
        if (typeof v2 === 'object' && !Array.isArray(v2)) {
          for (const [k3, v3] of Object.entries(v2)) {
            if (v3 !== null && v3 !== undefined) {
              parts.push(`${k}[${k2}][${k3}]=${encodeURIComponent(String(v3))}`);
            }
          }
        } else {
          parts.push(`${k}[${k2}]=${encodeURIComponent(String(v2))}`);
        }
      }
    } else {
      parts.push(`${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
    }
  }
  return parts.length ? '?' + parts.join('&') : '';
};

// ─── Object definitions ───────────────────────────────────────────────────────
export const listDefs   = (wsId, params)        => get(`${base(wsId)}${qs(params)}`);
export const getDef     = (wsId, objectId)      => get(`${base(wsId)}/${objectId}`);
export const createDef  = (wsId, dto)           => post(base(wsId), dto);
export const updateDef  = (wsId, objectId, dto) => patch(`${base(wsId)}/${objectId}`, dto);
export const deleteDef  = (wsId, objectId)      => del(`${base(wsId)}/${objectId}`);

// ─── Fields ───────────────────────────────────────────────────────────────────
export const listFields   = (wsId, objId, params)          => get(`${fieldBase(wsId, objId)}${qs(params)}`);
export const addField     = (wsId, objId, dto)             => post(fieldBase(wsId, objId), dto);
export const updateField  = (wsId, objId, fieldId, dto)    => patch(`${fieldBase(wsId, objId)}/${fieldId}`, dto);
export const archiveField = (wsId, objId, fieldId)         => del(`${fieldBase(wsId, objId)}/${fieldId}`);

// ─── Records ──────────────────────────────────────────────────────────────────
export const listRecords   = (wsId, objId, params)            => get(`${recordBase(wsId, objId)}${qs(params)}`);
export const getRecord     = (wsId, objId, recordId)          => get(`${recordBase(wsId, objId)}/${recordId}`);
export const createRecord  = (wsId, objId, dto)              => post(recordBase(wsId, objId), dto);
export const updateRecord  = (wsId, objId, recordId, dto)    => patch(`${recordBase(wsId, objId)}/${recordId}`, dto);
export const deleteRecord  = (wsId, objId, recordId)         => del(`${recordBase(wsId, objId)}/${recordId}`);

// ─── Relationship definitions (CO-006 backend) ────────────────────────────────
export const listRelationships   = (wsId, objId)             => get(relBase(wsId, objId));
export const createRelationship  = (wsId, objId, dto)        => post(relBase(wsId, objId), dto);
export const getRelationship     = (wsId, objId, relId)      => get(`${relBase(wsId, objId)}/${relId}`);
export const updateRelationship  = (wsId, objId, relId, dto) => patch(`${relBase(wsId, objId)}/${relId}`, dto);
export const deleteRelationship  = (wsId, objId, relId)      => del(`${relBase(wsId, objId)}/${relId}`);

// ─── Relationship links ────────────────────────────────────────────────────────
export const getRecordLinks = (wsId, objId, recordId)              => get(`${recordBase(wsId, objId)}/${recordId}/links`);
export const createLink     = (wsId, objId, recordId, relId, dto)  => post(`${recordBase(wsId, objId)}/${recordId}/links/${relId}`, dto);
export const deleteLink     = (wsId, objId, recordId, relId, linkId) => del(`${recordBase(wsId, objId)}/${recordId}/links/${relId}/${linkId}`);
export const reverseLinks   = (wsId, targetType, targetEntityId)   => get(`${base(wsId)}/related-to${qs({ targetType, targetEntityId })}`);
